<app-modal-container class="modal-width-50p no-modal-margin">
  <div class="modal-header-content">
    {{ 'bulk_change_status' | translate }}
  </div>
  <div class="modal-body-content">
    <div class="row mb-3">
      <div class="col-12 fw-bold text-black">
        {{ 'findings_selected_to_change_status' | translate: findings.length }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <label [for]="selectId">{{ 'change_status_to' | translate }}</label>
        <select [id]="selectId" [(ngModel)]="targetStatus" class="form-select">
          <option [ngValue]="null" disabled>{{ 'select_an_option' | translate }}</option>
          @for (status of targetStatusOptions; track $index) {
            <option [ngValue]="status">
              {{ AuditFindingQAStatusDisplayLabel[status] | translate }}
            </option>
          }
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer-content">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button class="btn btn-link fw-bold" (click)="container.closeModal()">
          {{ 'label_close' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" [disabled]="!targetStatus" (click)="changeStatus()">
          {{ 'change_status' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
